import React, { useEffect, useState } from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import { Column, Row } from "../../../pages/Users/UserDetail";
import Blank from "../../DefaultStyles/Blank";
import AgeSection from "./UserBoard/AgeSection";
import ExitSection from "./UserBoard/ExitSection";
import GenderSection from "./UserBoard/GenderSection";
import IndateSection from "./UserBoard/IndateSection";
import DashBoardDateFilter from "./DashBoardDateFilter";

export const getMaxChartValue = (preppedData: any[]) => {
  const max = preppedData.reduce((prev, current) =>
    prev.y > current.y ? prev : current
  );

  return max.y;
};

export const getMinChartValue = (preppedData: any[]) => {
  const maxArray = preppedData.map((data) =>
    data.reduce(
      (min: number, p: { y: number }) => (p.y < min ? p.y : min),
      data[0].y
    )
  );

  const min = Math.min(...maxArray);

  return Math.floor(min * 0.6);
};

export default function UserBoard() {
  const [indateFilter, setIndateFilter] = useState({
    startDate: dayjs().add(-7, "day")?.format("YYYY-MM-DD") ?? "",
    endDate: dayjs().add(-1, "day")?.format("YYYY-MM-DD") ?? "",
    isAccum: false,
  });

  const [ageFilter, setAgeFilter] = useState({
    startDate: "",
    endDate: "",
    isAccum: false,
  });

  const [genderFilter, setGenderFilter] = useState({
    startDate: "",
    endDate: "",
    isAccum: false,
  });

  const [exitFilter, setExitFilter] = useState({
    startDate: "",
    endDate: "",
    isAccum: false,
  });

  useEffect(() => {
    if (indateFilter.endDate !== "") {
      setAgeFilter({
        ...ageFilter,
        startDate: indateFilter.startDate,
        endDate: indateFilter.endDate,
      });

      setGenderFilter({
        ...genderFilter,
        startDate: indateFilter.startDate,
        endDate: indateFilter.endDate,
      });

      setExitFilter({
        ...exitFilter,
        startDate: indateFilter.startDate,
        endDate: indateFilter.endDate,
      });
    }
  }, [indateFilter]);

  return (
    <>
      <DashBoardSection>
        <DashBoardDateFilterContainer>
          <DashBoardDateFilter
            setFilter={setIndateFilter}
            filter={indateFilter}
            isAfter={{
              value: 31,
              unit: "day",
            }}
          />
        </DashBoardDateFilterContainer>

        {/* 가입자 추이 */}
        <IndateSection filter={indateFilter} setFilter={setIndateFilter} />

        <Row
          style={{
            gridTemplateColumns: "50% 50%",
            marginTop: 40,
            paddingRight: 20,
          }}
        >
          <Column>
            {/* 가입자 연령대 */}
            <AgeSection filter={ageFilter} setFilter={setAgeFilter} />
          </Column>
          <Column>
            {/* 가입자 성별 */}
            <GenderSection filter={genderFilter} setFilter={setGenderFilter} />
          </Column>
        </Row>

        <Blank blankHeight={40} />
        {/* 탈퇴자 추이 */}
        <ExitSection filter={exitFilter} setFilter={setExitFilter} />
      </DashBoardSection>
    </>
  );
}

export const DashBoardSection = styled.section`
  width: 100%;
  margin-top: 4px;
`;

export const DashBoardDateFilterContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 36px;

  @media screen and (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
